import Vue from 'vue'
import router from '../../router'
import Antd from 'ant-design-vue'

Vue.config.productionTip = false
Vue.use(Antd)

let vm = {
  delimiters: ['{', '}'],
  name: 'left-navbar',
  router,
  props: ['left_nav_list', 'title_top', 'title_top_path'],
  data: () => {
    return {
      path: window.location.pathname
      // title_top: 'ESG首页',
      // left_nav_list: [
      //   {path:'/home',label:'ESG评级和指标', subs: [{path:'/home',label:'行业ESG评级和指标'},{path:'/home',label:'公司ESG评级和指标'}]},
      //   {path:'/home',label:'ESG事件', subs: [{path:'/home',label:'环境歧视'}]},
      //   {path:'/supplychain',label:'供应链'},
      //   {path:'/home',label:'专利'}
      // ],
    }
  },
  methods: {
    changeTitleSelected () {
      this.path = decodeURI(window.location.pathname)
    },
    handleClick(e) {
      console.log('click', e);
    },
    titleClick(e) {
      console.log('titleClick', e);
    }
  },
  created () {
    this.path = decodeURI(window.location.pathname)
  }
}

export default vm



// WEBPACK FOOTER //
// ./src/entity/js/left_navbar.js